import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { useFirstDepositBonus } from '../hooks/useFirstDepositBonus';
import Icon from './Icon';

/**
 * First-deposit "free play" promo. `banner` = full card (Home, clickable to the
 * deposit screen); `callout` = compact strip (top of the deposit screens).
 * Renders nothing unless the player is eligible and the bonus is on.
 */
export default function FirstDepositBonusBanner({
  variant = 'banner',
  onClick,
}: {
  variant?: 'banner' | 'callout';
  onClick?: () => void;
}) {
  const { data } = useFirstDepositBonus();
  const { t } = useTranslation();
  const { colors } = useTheme();

  if (!data || !data.eligible || data.percent <= 0) return null;
  const percent = data.percent;

  if (variant === 'callout') {
    return (
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '10px 12px', borderRadius: 12, marginBottom: 16,
          backgroundColor: colors.accentSoft, border: `1.5px solid ${colors.accent}`,
          fontSize: 12.5, fontWeight: 700, color: colors.accentText,
        }}
      >
        <Icon name="gift" size={13} color={colors.accentText} />
        <span>{t('firstDepositBonus.calloutText', { percent })}</span>
      </div>
    );
  }

  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: 12,
        padding: 14, borderRadius: 16, marginBottom: 18,
        backgroundColor: colors.accentSoft, border: `1.5px solid ${colors.accent}`,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <div
        style={{
          width: 40, height: 40, borderRadius: 12, flexShrink: 0,
          backgroundColor: colors.accent,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        <Icon name="gift" size={18} color="#020617" />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 15, fontWeight: 900, color: colors.text }}>
          {t('firstDepositBonus.bannerTitle', { percent })}
        </div>
        <div style={{ fontSize: 12, lineHeight: 1.4, color: colors.textSub, marginTop: 2 }}>
          {t('firstDepositBonus.bannerBody', { percent })}
        </div>
      </div>
      {onClick && <Icon name="chevron-right" size={15} color={colors.textSub} />}
    </div>
  );
}
